import { Component, ElementRef, Input, OnChanges, OnInit} from '@angular/core';
import {MatTableModule} from '@angular/material/table';
import { PROCESSPARETOCOLUMNS } from 'src/app/common/constants/labels';
import * as c3 from 'c3';
import * as d3 from 'd3';

@Component({
  selector: 'app-process-pareto-report',
  templateUrl: './process-pareto-report.component.html',
  styleUrls: ['./process-pareto-report.component.scss']
})
export class ProcessParetoReportComponent implements OnInit, OnChanges {
  processParetoCol = PROCESSPARETOCOLUMNS;
  ppReportData = [];
  @Input() processParetoReportData: Array<any> = [];

  processpoint = [];
  defectpriorityindex = [];
  constructor() { }
  ngOnInit() {
  }

  ngOnChanges() {
    this.ppReportData = this.processParetoReportData;
    if (!this.processParetoReportData) {
      return;
    } else {
      this.processReportData(this.ppReportData);
    }
  }
  private processReportData(reportData: any[]) {
    const processpointArray = [];
    reportData.forEach(e => {
      processpointArray.push(e.processpoint);
    });
    this.processpoint = processpointArray;

    const defectpriorityindexArray = [];
    reportData.forEach(e => {
      defectpriorityindexArray.push(e.defectpriorityindex);
    });
    this.defectpriorityindex = defectpriorityindexArray;
    this.generateBarChart(this.processpoint, this.defectpriorityindex);
  }

  private generateBarChart(data1: any[], data2: any[]) {
    const dpiValues: any = [];
    const processpointname: any = [];
    const xaxisname = 'x';
    processpointname[0] = xaxisname;
    data1.forEach(e => {
      processpointname.push(e);
    });
    const dataname = 'Defect Priority Index';
    dpiValues[0] = dataname;
    data2.forEach(e => {
      dpiValues.push(e);
    });
    const processparetochart = c3.generate({
      bindto: '#processparetochart',
      size: {
        width: 1080,
        height: 400
      },
      data: {
        x: 'x',
        columns: [processpointname, dpiValues],
        type: 'bar',
        labels: true,
        // names: {data1: 'Defect Priorty Index'},
        axes: {
          data1: 'x'
        }
      },
      axis: {
        // rotated: true,
         x: {
           type: 'category'
         },
        y: {
          labels: 'Process Points'
        }
      }
  });
  }
}
